module.exports = __webpack_public_path__ + "img/pre_cert_bg.c8d42401.png";